import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavaidModel } from 'src/app/models/navaid';
import { NavaidStatus } from 'src/app/models/NavaidStatus';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { PointsService } from 'src/app/services/points.service';
import { DuplicateNavaidsComponent } from '../duplicate-navaids/duplicate-navaids.component';

@Component({
  selector: 'app-navaid-status',
  templateUrl: './navaid-status.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class NavaidStatusComponent implements OnInit {

  @Input() navaids : NavaidModel[];
  @Input() navaidsStatus : NavaidStatus[];

  constructor(private bsModalRef : BsModalRef,
    private pointsService : PointsService,
    private bsModalService : BsModalService,
    private modalService: ModalControlService,
    private navaidService : NavaidsService

    ) { }

  ngOnInit(): void {
  }

  cancelImport(): void {
    this.bsModalRef.hide();
  }

  importNavaids() : void {
    let navaidsToImport : NavaidModel[] = [];
    for (let i = 0; i<this.navaidsStatus.length; i++){
      if (this.navaidsStatus[i].status == "OK"){
        navaidsToImport.push(this.navaids[i]);
      }
    }
    if(navaidsToImport.length > 0) {
      DuplicateNavaidsComponent.importCheckForDuplicates(navaidsToImport,this.bsModalService,this.pointsService,this.navaidService,"CSV");
    }else {
      this.modalService.showMesssageModal("Import NavAids from CSV","None of the imported data is valid. Please correct the import options and repeat the process!");
    }

    this.bsModalRef.hide();
  }

}
